module.exports = __webpack_public_path__ + "static/media/gallery-view.7ab25cc7.svg";